import { render, staticRenderFns } from "./AddEditProduct.vue?vue&type=template&id=117cba91&scoped=true&"
import script from "./AddEditProduct.vue?vue&type=script&lang=js&"
export * from "./AddEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProduct.vue?vue&type=style&index=0&id=117cba91&lang=scss&scoped=true&"
import style1 from "./AddEditProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cba91",
  null
  
)

export default component.exports